import React from "react";
import PropTypes from "prop-types";
import S from "../../styles/components";

class ListSection extends React.PureComponent {
  render() {
    const { title, children, icon } = this.props;
    let sectionId = "section";
    if (this.props.id) sectionId = this.props.id;
    return (
      <div style={{ padding: "20px" }}>
        {icon ? (
          <S.ListSectionIcon>
            {icon}
            <S.ListSectionTitle style={{marginLeft:'5px'}}>{title}</S.ListSectionTitle>
          </S.ListSectionIcon>
        ) : (
          <S.ListSectionTitle>{title}</S.ListSectionTitle>
        )}
        <S.ListSectionContent id={sectionId}>
          {children.length ? (
            children
          ) : (
            <S.ListSectionNoData>
              {children.length ? children : "No data"}
            </S.ListSectionNoData>
          )}
        </S.ListSectionContent>
      </div>
    );
  }
}

export default ListSection;
